import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Card, Form, Spinner } from "react-bootstrap";
import { endpoints } from "../../helpers/Endpoints";
import { api } from "../../helpers/apiCore";
import errorInfoIcon from "../../assets/icons/error_info.svg";
import FormInput from "../../components/FormInput";

const CreateAdmin = () => {
	const navigate = useNavigate();

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [successMessage, setSuccessMessage] = useState<string | null>(null);
	const [roles, setRoles] = useState<{ id: string; name: string }[]>([]);
	const [formData, setFormData] = useState({
		first_name: "",
		last_name: "",
		email: "",
		phone_number: "",
		role_id: "",
		password: "",
	});
	
	useEffect(() => {
		const fetchRoles = async () => {
			try {
				api.setAuthorization(api.getLoggedInUser());
				const response = await api.get(endpoints.getAllRolesAndPermissions, {});
				console.log('Roles response:', response);
				setRoles(response?.data || []);
			} catch (error) {
				console.error("Error fetching roles:", error);
				setError("Failed to load roles");
				setShowAlert(true);
			}
		};
		fetchRoles();
	}, []);

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsSubmitting(true);
		setShowAlert(false);
		setError(null);

		try {
			api.setAuthorization(api.getLoggedInUser());
			
			const submitData = {
				first_name: formData.first_name.trim(),
				last_name: formData.last_name.trim(),
				email: formData.email.trim(),
				phone_number: formData.phone_number.trim(),
				role_id: parseInt(formData.role_id),
				password: formData.password,
			};

			const response = await api.create(endpoints.createAdmin, submitData);
			
			setSuccessMessage("Admin invitation sent successfully.");
			setShowAlert(true);
			
			setFormData({
				first_name: "",
				last_name: "",
				email: "",
				phone_number: "",
				role_id: "",
				password: "",
			});

			setTimeout(() => {
				navigate(`/auth/activate-account?email=${encodeURIComponent(submitData.email)}`);
			}, 2000);
		} catch (error: any) {
			console.error('Submit error:', error);
			const message = error?.response?.data?.message || 'Unable to invite admin, please try again';
			setError(message);
			setShowAlert(true);
			setSuccessMessage(null);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
		setError(null);
		setShowAlert(false);
		const { name, value } = e.target;
		setFormData((prevFormData) => ({
			...prevFormData,
			[name]: value,
		}));
	};

	useEffect(() => {
		let alertTimeout: string | number | NodeJS.Timeout | undefined;
		if (showAlert) {
			alertTimeout = setTimeout(() => {
				setShowAlert(false);
				setError(null);
			}, 4000);
		}
		return () => clearTimeout(alertTimeout);
	}, [showAlert]);

	const isFormValid = () => {
		return (
			formData.first_name.trim() &&
			formData.last_name.trim() &&
			formData.email.trim() &&
			formData.phone_number.trim() &&
			formData.role_id &&
			formData.password.trim()
		);
	};

	return (
		<>
			<Card className="form-container text-left mt-3">
				<Card.Body className="create-form-body">
					<form onSubmit={handleSubmit}>
						<p>Basic Information</p>

						<div className="card-form-row">
							<FormInput
								type="text"
								label="First Name"
								name="first_name"
								className="custom-input"
								value={formData.first_name}
								onChange={handleChange}
								required
							/>

							<FormInput
								type="text"
								label="Last Name"
								name="last_name"
								className="custom-input"
								value={formData.last_name}
								onChange={handleChange}
								required
							/>
		
							<FormInput
								type="email"
								label="Email"
								name="email"
								className="custom-input"
								value={formData.email}
								onChange={handleChange}
								required
							/>

							<FormInput
								type="tel"
								label="Phone Number"
								name="phone_number"
								className="custom-input"
								value={formData.phone_number}
								onChange={handleChange}
								placeholder="e.g., +1234567890"
								required
							/>

							<FormInput
								type="password"
								label="Password"
								name="password"
								className="custom-input"
								value={formData.password}
								onChange={handleChange}
								placeholder="Enter password"
								required
							/>

							<div className="role-select">
								<label>Role</label>

								<Form.Select 
									name="role_id" 
									value={formData.role_id} 
									onChange={handleChange} 
									className="custom-select"
									required
								>
									<option value="">Select Role</option>
									{roles?.map((role) => (
										<option key={role.id} value={role.id}>
											{role.name}
										</option>
									))}
								</Form.Select>
							</div>
						</div>

						{showAlert && (
							<Alert
								variant={error ? 'danger' : 'success'}
								className={error ? 'alert-error' : 'alert-success'}
							>
								{error && <img src={errorInfoIcon} alt="error" />}
								{error ? error : successMessage}
							</Alert>
						)}

						<Button
							type="submit"
							className="custom-button"
							disabled={isSubmitting || !isFormValid()}
						>
							{isSubmitting ? <Spinner animation="border" size="sm" /> : "Send Invite"}
						</Button>
					</form>
				</Card.Body>
			</Card>
		</>
	);
};

export default CreateAdmin;


// import React, { useEffect, useState } from "react";
// import { Alert, Button, Card, Form, Spinner } from "react-bootstrap";
// import { endpoints } from "../../helpers/Endpoints";
// import { api } from "../../helpers/apiCore";
// import errorInfoIcon from "../../assets/icons/error_info.svg";
// import FormInput from "../../components/FormInput";

// const CreateAdmin = () => {
// 	const [isSubmitting, setIsSubmitting] = useState(false);
// 	const [showAlert, setShowAlert] = useState(false);
// 	const [error, setError] = useState<string | null>(null);
// 	const [successMessage, setSuccessMessage] = useState<string | null>(null);
// 	const [roles, setRoles] = useState<{ id: string; name: string }[]>([]);
// 	const [formData, setFormData] = useState({
// 		first_name: "",
// 		last_name: "",
// 		email: "",
// 		phone_number: "",
// 		role_id: 0,
// 		password: "",
// 	});

// 	useEffect(() => {
// 		const fetchRoles = async () => {
// 			try {
// 				api.setAuthorization(api.getLoggedInUser());
// 				const response = await api.get(endpoints.getAllRolesAndPermissions, {});
// 				setRoles(response?.data);
// 			} catch (error) {
// 				console.error("Error fetching roles:", error);
// 			}
// 		};
// 		fetchRoles();
// 	}, []);

// 	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
// 		e.preventDefault();
// 		setIsSubmitting(true);
// 		setShowAlert(false);
// 		try {
// 			api.setAuthorization(api.getLoggedInUser());
// 			const response = await api.create(endpoints.createAdmin, {
// 				...formData,
// 				role_id: formData.role_id,
// 			});
// 			setSuccessMessage("Admin invitation sent successfully.");
// 			setShowAlert(true);
// 			setFormData({
// 				first_name: "",
// 				last_name: "",
// 				email: "",
// 				phone_number: "",
// 				role_id: 0,
// 				password: "",
// 			});
// 		} catch (error: any) {
// 			const message = error?.response?.data?.message || 'Unable to invite admin, please try again';
// 			setError(message);
// 			setShowAlert(true);
// 			setSuccessMessage(null);
// 		} finally {
// 			setIsSubmitting(false);
// 		}
// 	};

// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
// 		setError(null);
// 		const { name, value } = e.target;
// 		setFormData((prevFormData) => ({
// 			...prevFormData,
// 			[name]: value,
// 		}));
// 	};

// 	useEffect(() => {
// 		let alertTimeout: string | number | NodeJS.Timeout | undefined;
// 		if (showAlert) {
// 			alertTimeout = setTimeout(() => {
// 				setShowAlert(false);
// 				setError(null);
// 			}, 4000);
// 		}
// 		return () => clearTimeout(alertTimeout);
// 	}, [showAlert]);

// 	return (
// 		<>
// 			<Card className="form-container text-left mt-3">
// 				<Card.Body className="create-form-body">
// 					<form onSubmit={handleSubmit}>
// 						<p>Basic Information</p>

// 						<div className="card-form-row">
// 							<FormInput
// 								type="text"
// 								label="First Name"
// 								name="first_name"
// 								className="custom-input"
// 								value={formData.first_name}
// 								onChange={handleChange}
// 							/>

// 							<FormInput
// 								type="text"
// 								label="Last Name"
// 								name="last_name"
// 								className="custom-input"
// 								value={formData.last_name}
// 								onChange={handleChange}
// 							/>
		
// 							<FormInput
// 								type="email"
// 								label="Email"
// 								name="email"
// 								className="custom-input"
// 								value={formData.email}
// 								onChange={handleChange}
// 							/>

// 							<div className="role-select">
// 								<label>Role</label>

// 								<Form.Select name="role_id" value={formData.role_id} onChange={handleChange} className="custom-select">
// 									<option value="">Select Role</option>
// 									{roles?.map((role) => (
// 										<option key={role.id} value={role.id}>{role.name}</option>
// 									))}
// 								</Form.Select>
// 							</div>
// 						</div>

// 						{showAlert && (
// 							<Alert
// 								variant={error ? 'danger' : 'success'}
// 								className={error ? 'alert-error' : 'alert-success'}
// 							>
// 								{error && <img src={errorInfoIcon} alt="error" />}
// 								{error ? error : successMessage}
// 							</Alert>
// 						)}

// 						<Button
// 							type="submit"
// 							className="custom-button"
// 							disabled={isSubmitting || !formData.first_name || !formData.last_name || !formData.email || !formData.role_id}
// 						>
// 							{isSubmitting ? <Spinner animation="border" size="sm" /> : "Send Invite"}
// 						</Button>
// 					</form>
// 				</Card.Body>
// 			</Card>
// 		</>
// 	);
// };

// export default CreateAdmin;
